import { Inject, Injectable } from '@angular/core';
import { ConfigInstanceToken, ConfigInterface } from '../../interfaces/config.interface';
import { UserGidInterface } from '../../interfaces/user-gid.interface';

@Injectable()
export class UserGidService implements UserGidInterface {
    private userGid = '';
    public constructor(@Inject(ConfigInstanceToken) private readonly configService: ConfigInterface) {}

    public getUserGid(): string {
        if (this.userGid.length === 0) {
            if (this.configService.isInitialized) {
                this.userGid = this.configService.getUserFrontId();
            }
        }
        return this.userGid;
    }

    public setUserGid(gid: string): void {
        // to avoid overwriting values we only assign value if userGid is not previously assigned
        if (this.userGid.length === 0 && gid.length > 0) {
            this.userGid = gid;
        }
    }
}
